import * as React from 'react';
import { useTheme } from '../../../../../theme';
import cn from 'classnames';
import { Slide } from '@mui/material';

interface Props {
	open?: boolean;
}

const FullscreenPopup: React.FC<Props> = props => {
	const theme = useTheme('PassengerForm').FullscreenPopup;

	React.useEffect(() => {
		window.document.body.style.overflow = props.open ? 'hidden' : '';
	}, [props.open]);

	return (
		<Slide direction="up" in={props.open}>
			<div className={cn(theme.popup, { [theme.visible]: props.open })}>{props.children}</div>
		</Slide>
	);
};

export default FullscreenPopup;
